module.exports = __webpack_public_path__ + "img/borderEllipseWhite.922e77ab.svg";